<template>
    <div>
        <div class="row" id="headlines-page">
            <div class="col-lg-12 mt-3 text-center" id="headlines">
                <div class="headline-item mb-1 d-none"></div>
                <div class="headline-item mb-1 d-none"></div>
                <div class="headline-item mb-1 d-none"></div>
                <div :class="{active: $route.name === 'register'}" class="headline-item mb-1"
                     @click="onHeadlineClicked('register')">
                    <h5>ثبت اطلاعات مالیاتی</h5>
                </div>
                <div :class="{active: $route.name === 'sellFactors'}" class="headline-item mb-1"
                     @click="onHeadlineClicked('sellFactors')">
                    <h5>ارسال فاکتورهای فروش</h5>
                </div>
                <div :class="{active: $route.name === 'sentFactors'}" class="headline-item mb-1"
                     @click="onHeadlineClicked('sentFactors')">
                    <h5>پیگیری ارسال شده ها</h5>
                </div>
                <div :class="{active: $route.name === 'successFactors'}" class="headline-item mb-1"
                     @click="onHeadlineClicked('successFactors')">
                    <h5>تایید شده ها</h5>
                </div>

            </div>
            <div class="col-lg-12 mt-2">
                <transition
                        name="fade"
                        mode="out-in"
                >
                    <router-view/>
                </transition>
            </div>
            <div class="sk-circle" id="loadings">
                <div class="sk-circle1 sk-child"></div>
                <div class="sk-circle2 sk-child"></div>
                <div class="sk-circle3 sk-child"></div>
                <div class="sk-circle4 sk-child"></div>
                <div class="sk-circle5 sk-child"></div>
                <div class="sk-circle6 sk-child"></div>
                <div class="sk-circle7 sk-child"></div>
                <div class="sk-circle8 sk-child"></div>
                <div class="sk-circle9 sk-child"></div>
                <div class="sk-circle10 sk-child"></div>
                <div class="sk-circle11 sk-child"></div>
                <div class="sk-circle12 sk-child"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import * as $ from 'jquery';
    import axios from 'axios';
    import Vue from 'vue';
    import BaseService from "../_framework/api/BaseService";
    import Utils from "../_framework/utils/Utils";

    $(function () {
        var pos1 = 0;
        $(window).scroll(function () {
            var pos2 = $(window).scrollTop();
            if (pos2 > pos1) {
                $(".search-area").addClass("hidden");
            }
            if (pos1 > pos2) {
                $(".search-area").removeClass("hidden");
            }
            pos1 = pos2;
        })
    });

    //$(".product-container:nth-child(1)").css("background-color","green");
    $(".voucher-modal-button").click(() => {
        $("#voucherData").modal("show");
    });

    export default {
        name: 'haedlines',
        components: {},
        data() {
            return {
                providers: [],
                categories: [],
                queryParams: {
                    pageSize: 18,
                    pageIndex: 0,
                    name: "",
                    categoryId: 0
                },
                searchString: "",
                modalProductName: "",
                cart: []
            }
        },
        mounted() {
            $("#loadings").hide();
        },
        methods: {
            onHeadlineClicked(headline) {
                this.$router.push({
                    name: `${headline}`,

                });
            }
        }
    }
</script>

<style scoped>
    #loading {
        position: absolute;
        top: calc(40% - 40px);
        left: calc(50% - 40px);
    }
</style>